<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">My Performance</h1>
          </div><!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">My Performance</li>
            </ol>
          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
            <div class="col-md-3 col-sm-6 col-12">
              <div class="info-box">
                <span class="info-box-icon bg-info"><i class="far fa-envelope"></i></span>
  
                <div class="info-box-content">
                  <span class="info-box-text">Messages</span>
                  <span class="info-box-number">1,410</span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
              <div class="info-box">
                <span class="info-box-icon bg-success"><i class="far fa-flag"></i></span>
  
                <div class="info-box-content">
                  <span class="info-box-text">Bookmarks</span>
                  <span class="info-box-number">410</span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
              <div class="info-box">
                <span class="info-box-icon bg-warning"><i class="far fa-copy"></i></span>
  
                <div class="info-box-content">
                  <span class="info-box-text">Uploads</span>
                  <span class="info-box-number">13,648</span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-3 col-sm-6 col-12">
              <div class="info-box">
                <span class="info-box-icon bg-danger"><i class="far fa-star"></i></span>
  
                <div class="info-box-content">
                  <span class="info-box-text">Likes</span>
                  <span class="info-box-number">93,139</span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
            <!-- /.col -->
          </div>
        <div class="row">
          <div class="col-lg-6">


               
            <div class="card card-success">
                <div class="card-header">
                  <h3 class="card-title">Assesment Wise Performance </h3>
  
                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                      <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div class="chart">
                    <canvas id="barChart" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>
                  </div>
                </div>
                <!-- /.card-body -->
              </div>
              
            <!-- /.card -->

            <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Assesment Report  </h3>
  
                  <!-- <div class="card-tools">
                    <ul class="pagination pagination-sm float-right">
                      <li class="page-item"><a class="page-link" href="#">«</a></li>
                      <li class="page-item"><a class="page-link" href="#">1</a></li>
                      <li class="page-item"><a class="page-link" href="#">2</a></li>
                      <li class="page-item"><a class="page-link" href="#">3</a></li>
                      <li class="page-item"><a class="page-link" href="#">»</a></li>
                    </ul>
                  </div> -->
                </div>
                <!-- /.card-header -->
                <div class="card-body p-0">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 10px">Assesment</th>
                        <th>Score</th>
                        <th>%</th>
                        <th style="width: 40px">Rank</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <td><a href="pages/examples/invoice.html">FA01</a></td>
                          <td>580/600</td>
                          <td><span class="badge badge-success">96.66%</span></td>
                          <td>
                            <div class="sparkbar" data-color="#00a65a" data-height="20">10<sup>th</sup> </div>
                          </td>
                          <td>
                            <a href="#" class="text-muted">
                              <i class="fas fa-eye"></i>
    
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td><a href="pages/examples/invoice.html">FA02</a></td>
                          <td>580/600</td>
                          <td><span class="badge badge-warning">96.66%</span></td>
                          <td>
                            <div class="sparkbar" data-color="#f39c12" data-height="20">10<sup>th</sup> </div>
                          </td>
                          <td>
                            <a href="#" class="text-muted">
                              <i class="fas fa-eye"></i>
    
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td><a href="pages/examples/invoice.html">SA01</a></td>
                          <td>580/600</td>
                          <td><span class="badge badge-danger">96.66%</span></td>
                          <td>
                            <div class="sparkbar" data-color="#f56954" data-height="20">10<sup>th</sup> </div>
                          </td>
                          <td>
                            <a href="#" class="text-muted">
                              <i class="fas fa-eye"></i>
    
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td><a href="pages/examples/invoice.html">FA03</a></td>
                          <td>580/600</td>
                          <td><span class="badge badge-info">96.66%</span></td>
                          <td>
                            <div class="sparkbar" data-color="#00c0ef" data-height="20">10<sup>th</sup> </div>
                          </td>
                          <td>
                            <a href="#" class="text-muted">
                              <i class="fas fa-eye"></i>
    
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td><a href="pages/examples/invoice.html">FA04</a></td>
                          <td>580/600</td>
                          <td><span class="badge badge-warning">96.66%</span></td>
                          <td>
                            <div class="sparkbar" data-color="#f39c12" data-height="20">10<sup>th</sup> </div>
                          </td>
                          <td>
                            <a href="#" class="text-muted">
                              <i class="fas fa-eye"></i>
    
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td><a href="pages/examples/invoice.html">SA02</a></td>
                          <td>580/600</td>
                          <td><span class="badge badge-danger">96.66%</span></td>
                          <td>
                            <div class="sparkbar" data-color="#f56954" data-height="20">10<sup>th</sup></div>
                          </td>
                          <td>
                            <a href="#" class="text-muted">
                              <i class="fas fa-eye"></i>
    
                            </a>
                          </td>
                        </tr>
                       
                        </tbody>
                  </table>
                </div>
                <!-- /.card-body -->
              </div>
            <!-- /.card -->
          </div>
          <!-- /.col-md-6 -->
          <div class="col-lg-6">
              
            
            <div class="card card-info">
                <div class="card-header">
                  <h3 class="card-title">Subject Wise Performance</h3>
  
                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                      <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div class="chart">
                    <canvas id="lineChart" style="min-height: 250px; height: 250px; max-height: 250px; max-width: 100%;"></canvas>
                  </div>
                </div>
                <!-- /.card-body -->
              </div>
                
            <!-- /.card -->

            <div class="card">
                <div class="card-header border-0">
                  <h3 class="card-title">Attendence</h3>
                  <div class="card-tools">
                    <a href="#" class="btn btn-tool btn-sm">
                      <i class="fas fa-download"></i>
                    </a>
                    <a href="#" class="btn btn-tool btn-sm">
                      <i class="fas fa-bars"></i>
                    </a>
                  </div>
                </div>
                <div class="card-body table-responsive p-0">
                  <table class="table table-striped table-valign-middle">
                    <thead>
                    <tr>
                      <th>Subject</th>
                      <th>Present</th>
                      <th>Absent</th>
                      <th>%</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>
                     
                        Some Product
                      </td>
                      <td>$13 USD</td>
                      <td></td>
                      <td>
                        <small class="text-success mr-1">
                          <i class="fas fa-arrow-up"></i>
                          12%
                        </small>
                      
                      </td>
                      <td>
                        <a href="#" class="text-muted">
                          <i class="fas fa-eye"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                
                        Another Product
                      </td>
                      <td>$29 USD</td>
                      <td></td>
                      <td>
                        <small class="text-warning mr-1">
                          <i class="fas fa-arrow-down"></i>
                          0.5%
                        </small>
                      
                      </td>
                      <td>
                        <a href="#" class="text-muted">
                          <i class="fas fa-eye"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                    
                        Amazing Product
                      </td>
                      <td>$1,230 USD</td>
                      <td></td>
                      <td>
                        <small class="text-danger mr-1">
                          <i class="fas fa-arrow-down"></i>
                          3%
                        </small>
                     
                      </td>
                      <td>
                        <a href="#" class="text-muted">
                          <i class="fas fa-eye"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                 
                        Perfect Item
                        <span class="badge bg-danger">NEW</span>
                      </td>
                      <td>$199 USD</td>
                      <td></td>
                      <td>
                        <small class="text-success mr-1">
                          <i class="fas fa-arrow-up"></i>
                          63%
                        </small>
                        
                      </td>
                      <td>
                        <a href="#" class="text-muted">
                          <i class="fas fa-eye"></i>

                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
          <!-- /.col-md-6 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
